module.exports = __webpack_public_path__ + "img/respecth-results.d0bdaa0d.png";